<div class="status-container" [matTooltip]="title">
  <div class="status"></div>
  <span class="label">{{name}}</span>
</div>
